import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

import Video from '../../../ui-core/Video';
import { IMAGE_CONSTANT, LOCAL_STORAGE_CONSTANT } from '../../../constants/app';
import Button from '../../../ui-core/Button/Button';
import useWindowWidth from '../../../hooks/useWindowWidth';
import { getDisplayType } from '../../../utils/helpers';
import { extractJSON } from '../../../services/jsonUtil';

import './style.css';

const VideoWrapper = props => {
  const iconRef = useRef(null);
  const videoRef = useRef(null);
  const videoPausedRef = useRef(true);
  const isMobileScreen = getDisplayType(useWindowWidth()) === 'mobile';
  const [videoLoaded, setVideoLoaded] = useState(false);

  const togglePlayPause = () => {
    if (!videoRef.current) {
      return;
    }
    if (videoPausedRef.current) {
      videoRef.current.play();
      videoPausedRef.current = false;
      if (iconRef.current) {
        iconRef.current.src = IMAGE_CONSTANT.pauseCircle;
        iconRef.current.classList.add('d-none');
      }
    } else {
      videoRef.current.pause();
      videoPausedRef.current = true;
      if (iconRef.current) {
        iconRef.current.src = IMAGE_CONSTANT.playCircle;
      }
    }
  };

  return (
    <div className="position-relative">
      <Video
        autoPlay={false}
        controls={true}
        mp4={props.video.mp4}
        muted={false}
        ref={videoRef}
        onLoadedData={() => setVideoLoaded(true)}
        webm={props.video.webm}
      />
      {!isMobileScreen && videoLoaded && (
        <img
          alt="play-pause-icon"
          className="cursor-pointer big-play-icon"
          onClick={togglePlayPause}
          ref={iconRef}
          src={IMAGE_CONSTANT.playCircle}
        />
      )}
    </div>
  );
};

const VideoSection = props => {
  const user = extractJSON(LOCAL_STORAGE_CONSTANT.USER);
  const handleClick = () => {
    if (props.onClick) {
      props.onClick(props.btnText, 'isSignup', props.title);
    }
  };

  return (
    <div className="video-wrapper align-items-center">
      <h2 className="full-body-video-h2 text-center">{props.title}</h2>
      <iframe
        className="video-iframe"
        src="https://www.youtube.com/embed/V6iLS8XG78o"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
      {!user && (
        <Button
          onClick={handleClick}
          text={props.btnText}
          class="sign-up-button-new text-uppercase"
        />
      )}
    </div>
  );
};

VideoWrapper.propTypes = {
  video: PropTypes.shape({
    mp4: PropTypes.string.isRequired,
    webm: PropTypes.string.isRequired,
  }).isRequired,
};

VideoSection.propTypes = {
  onClick: PropTypes.func,
  title: PropTypes.string.isRequired,
  btnText: PropTypes.string.isRequired,
  video: PropTypes.shape({
    mp4: PropTypes.string.isRequired,
    webm: PropTypes.string.isRequired,
  }).isRequired,
};

export default VideoSection;
